import { render, staticRenderFns } from "./TabelHeaderForNewOrder.vue?vue&type=template&id=7fffc292&"
import script from "./TabelHeaderForNewOrder.vue?vue&type=script&lang=js&"
export * from "./TabelHeaderForNewOrder.vue?vue&type=script&lang=js&"
import style0 from "./TabelHeaderForNewOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fffc292')) {
      api.createRecord('7fffc292', component.options)
    } else {
      api.reload('7fffc292', component.options)
    }
    module.hot.accept("./TabelHeaderForNewOrder.vue?vue&type=template&id=7fffc292&", function () {
      api.rerender('7fffc292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeliveryNote/Outsourced/components/TabelHeaderForNewOrder.vue"
export default component.exports